import { Outlet } from "react-router-dom";

export const MobileOnlyLayout = () => {
  return (
    <div className="MobileOnlyLayout relative mx-auto flex min-h-screen flex-col sm:w-[390px] sm:border">
      <Outlet />
    </div>
  );
};
